import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper/modules"; // ⬅️ import Navigation
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"; // ⬅️ include navigation CSS

const CoreSlider2 = ({ gamedevservices }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <div style={{ position: "relative" }}>
      <Swiper
        slidesPerView={4.2}
        spaceBetween={30}
        freeMode={true}
        pagination={{ clickable: true }}
        navigation={true} // ⬅️ enable navigation
        modules={[FreeMode, Pagination, Navigation]} // ⬅️ add Navigation module
        className="mySwiper"
        breakpoints={{
          0: { slidesPerView: 1.2 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1200: { slidesPerView: 4.2 },
        }}
      >
        {gamedevservices.map((val, i) => {
          const isExpanded = expandedIndex === i;

          return (
            <SwiperSlide key={i}>
              <div
                className="text-center"
                style={{ minHeight: 450, width: 245, marginBottom: 30 }}
              >
                <div className="border h-100 bg-light d-flex flex-column">
                  <Link to={val.link}>
                    <img
                      src={val.icon}
                      alt=""
                      className="mx-0 my-0 w-100"
                      style={{ height: 186, objectFit: "cover" }}
                    />
                  </Link>
                  <h3 className="fs-5 my-3 px-2 h3-heading">{val.title}</h3>

                  <p
                    className={`fs-6 h3-para px-2 lh-base ${
                      !isExpanded ? "text-truncate-3" : ""
                    }`}
                    style={{ flexGrow: 1 }}
                  >
                    {val.desc}
                  </p>

                  <button
                    className="btn btn-link text-primary px-2 pb-3 text-gradient text-decoration-underline"
                    style={{ fontSize: "0.875rem" }}
                    onClick={() => setExpandedIndex(isExpanded ? null : i)}
                  >
                    {isExpanded ? "Read less" : "Read more"}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default CoreSlider2;
